export const specialRound = (num: number) => {
  const factor = 100000; // Work with 5 decimal places
  const roundedToFive = Math.floor(num * factor) / factor; // Always round down to 5 decimals

  return Math.round(roundedToFive * 100) / 100; // Then round to 2 decimals
};
